App.OrdersOrderModalController = Em.Controller.extend
  needs: [ 'orders' ]

  orderBinding:       'model'

  organizationBinding: 'order.organization'
  restaurantsBinding:  'organization.restaurants'
  zonesBinding:        'organization.delivery_zones'

  couriers: (->
    restaurant = @get('model.restaurant.id')

    @get('controllers.orders.couriers').filter (el)-> 
      # у пользователя могут быть недоступны рестораны, к которых относится курьер,
      # делаем фильтрацию таким образом, чтобы не инициировать запрос недоступных ресторанов
      !el.get('disabled') && el._data.restaurants.length == 0 || el._data.restaurants.map((v) -> v.id).indexOf(restaurant) > -1
  ).property('order.restaurant','controllers.orders.couriers')

  actions:
    transitionTo: (args...) ->
      @transitionToRoute(args...)
      false
